import { render } from "./ConnectedSocial.vue?vue&type=template&id=48f64296&scoped=true"
import script from "./ConnectedSocial.vue?vue&type=script&lang=js"
export * from "./ConnectedSocial.vue?vue&type=script&lang=js"

import "./ConnectedSocial.vue?vue&type=style&index=0&id=48f64296&scoped=true&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f64296"]])

export default __exports__